export default __webpack_public_path__ + "locales/uk-UA/FilesSettings.json?hash=e30e39f2053eb0cd34800cbc11cc22e9";